import { ConfigPath } from '../../../../../config/app/types';
import { configureAndLoad, launchQuoteForm } from './sdk';
import { getRedirect, getRedirectBack } from './utils/get-redirect';
import { sharedInstance as queue } from './queue';
import config from '../../../config';

queue.beforeAll(() => {
  // @ts-expect-error - Automatic, Please fix when editing this file
  configureAndLoad({ config: config.get('open'), onLoad: queue.start.bind(queue) });
});

const launchOpenQuoteForm = ({ productSlug, inNewTab = true }: { productSlug: string; inNewTab?: boolean }) => {
  const productId = config.get(`open:products:${productSlug}` as ConfigPath) as string;
  if (!productId) {
    return false;
  }
  const redirect = getRedirect(productSlug);
  const redirectBack = getRedirectBack(productSlug);
  queue.add('launch', () => {
    launchQuoteForm({ inNewTab, productId, productSlug, redirect, redirectBack });
  });
  return true;
};

export default launchOpenQuoteForm;
